import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Добавьте новую услугу в портфель',
    desc: 'Квалифицированные заявки — это то, что нужно каждому бизнесу. Предлагайте их своим клиентам как отдельный продукт и зарабатывайте на разнице.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Белая упаковка под ваш бренд',
    desc: 'Клиент не видит AIGAM — он видит вас. Отчёты, заявки, коммуникация — всё идёт от вашего имени.',
  },
  {
    icon: 'ri-percent-line',
    title: 'Ваша маржа не ограничена',
    desc: 'Вы сами назначаете цену для клиента. Разница между вашей ценой и нашей — это ваш чистый доход. Никаких потолков.',
  },
  {
    icon: 'ri-team-line',
    title: 'Мы делаем всю работу',
    desc: 'ИИ сам находит аудиторию, пишет первым, квалифицирует и передаёт контакты. Вы — лицо услуги, мы — исполнение.',
  },
];

export default function PartnerResell() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-accent-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Агентствам и фрилансерам
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Продавайте заявки своим клиентам под вашим брендом
          </h2>
          <p ref={descRef} className={`mt-4 text-[15px] md:text-[16px] text-foreground-500 max-w-2xl mx-auto leading-relaxed reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
            Вы — агентство или частный специалист. У вас есть клиенты, которым нужны лиды. AIGAM становится вашим backend-исполнителем: мы генерируем заявки, а вы продаёте их как свою услугу с собственной наценкой.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {benefits.map((item, i) => (
            <div
              key={item.title}
              className={`rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-accent-500/40 transition-all duration-300 group reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''}`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 100}ms` } : undefined}
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 group-hover:scale-110 transition-all">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-display font-bold text-[16px] md:text-[17px] text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-[13px] md:text-[14px] text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 p-5 md:p-6 rounded-2xl bg-accent-50/50 border border-accent-200/50 max-w-3xl mx-auto">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
              <i className="ri-lightbulb-line text-accent-600"></i>
            </div>
            <div>
              <p className="text-[14px] md:text-[15px] text-foreground-700 leading-relaxed">
                <strong className="text-foreground-950">Пример.</strong> Вы берёте у клиента 80 000 ₽ в месяц за заявки под ключ. Наша стоимость — 56 000 ₽. Ваша маржа — 24 000 ₽ с одного клиента ежемесячно. Три клиента = 72 000 ₽ пассивного дохода.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}